/// <reference types="cypress" />

import axios from 'axios';
import { store } from '../store';

const isTest = process.env.NODE_ENV === 'test' || window.Cypress;
const isE2ETest = process.env.E2E === 'true' || (window as any).__E2E_TEST__;

// Cypressの型定義を追加
declare global {
  interface Window {
    Cypress?: Cypress.Cypress;
  }
}

const baseURL = isTest || isE2ETest
  ? 'http://localhost:8000'  // テスト環境ではバックエンドサーバーに直接接続
  : process.env.NODE_ENV === 'production'
    ? 'https://api.license-gd.com'  // 本番環境ではカスタムドメインを使用
    : '/api';  // 開発環境ではプロキシを使用

const client = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,  // CORSリクエストでクッキーを送信
});

// リクエストインターセプター
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// レスポンスインターセプター
client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // ログインAPIでは自動リフレッシュを無効にする
    if (originalRequest._skipRetry || originalRequest.url?.includes('/auth/login')) {
      return Promise.reject(error);
    }

    // 401エラーでリフレッシュトークンがある場合
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          throw new Error('No refresh token');
        }

        const response = await client.post('/auth/refresh', { refreshToken });
        const { token } = response.data;

        localStorage.setItem('accessToken', token);
        originalRequest.headers.Authorization = `Bearer ${token}`;

        return client(originalRequest);
      } catch (refreshError) {
        // リフレッシュトークンが無効な場合はログアウト
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        
        // テスト環境では自動リダイレクトを無効にする
        const isE2ETest = (window as any).__E2E_TEST__;
        if (!isTest && !isE2ETest) {
          window.location.href = '/login';
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default client;
export { client as apiClient }; 